/**
 * Who raised an RFI. Admin RFIs are authored end to end by a human and carry
 * their requested documents from the start; processor RFIs are opened
 * automatically when a payment rail parks a transaction pending information,
 * and start life as a Draft with no documents named yet.
 */
export var BusinessRFISource;
(function (BusinessRFISource) {
    BusinessRFISource["Admin"] = "ADMIN";
    BusinessRFISource["Processor"] = "PROCESSOR";
})(BusinessRFISource || (BusinessRFISource = {}));
//# sourceMappingURL=BusinessRFISource.js.map